import { get, isEmpty } from 'lodash';
import moment from 'moment';
import React from 'react';
import { MomentFormats, toValidateIfDate, useDate } from '../../../../common/utils/date';
import ExpandableTemplate from '../kendo/ExpandableTemplate';
import { CustomGridCellProps } from '../kendo/types';

export const GroupCell = ({
  dataItem,
  field,
  rowType,
  colSpan,
  style,
  className,
  columnIndex,
  cellRowClick,
}: CustomGridCellProps) => {
  const value = get(dataItem, field || '');
  const toCheckIfDate = toValidateIfDate(value);
  const { getFormattedDateString, formatDisplayDate } = useDate();
  let formattedValue = toCheckIfDate
    ? getFormattedDateString(value, MomentFormats.MonthDateYear)
    : value;

  if (Array.isArray(value)) {
    formattedValue = value.join(', ');
  }

  const cellClickEvent = () => {
    if (!cellRowClick) { return; }
    cellRowClick({ dataItem });
  };

  if (rowType === 'groupHeader') {
    return null;
  }

  if (formattedValue && moment.utc(formattedValue, moment.ISO_8601, true).isValid()) {
    formattedValue = formatDisplayDate(formattedValue);
  }
  const dataItems = isEmpty(formattedValue) ? [] : formattedValue.split(',');

  return (
    <td
      colSpan={colSpan}
      style={style}
      role="gridcell"
      className={className}
      data-grid-col-index={columnIndex}
      onClick={cellClickEvent}
      id="kendo-expandable-column"
    >
      <ExpandableTemplate
        items={dataItems}
        dataId={`${dataItem.id}-${columnIndex}`}
      />
    </td>
  );
};
